unit uSubForm2;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls, WEBLib.Controls, WEBLib.Grids,
  WEBLib.DBCtrls, Data.DB, WEBLib.CDS, WEBLib.DB, WEBLib.Buttons,
  VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCImage, WEBLib.ExtCtrls, Vcl.Grids,
  Vcl.Imaging.pngimage, VCL.TMSFNCTrackBar,
  SysUtils, Variants, Classes, Graphics, Controls, Forms,
  Dialogs, ExtCtrls, StdCtrls, StrUtils, Vcl.Imaging.jpeg;

type
  TSubForm2 = class(TForm)
    WebLabel26: TLabel;
    WebLabel7: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel16: TLabel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebComboBox6: TComboBox;
    WebComboBox5: TComboBox;
    WebComboBox4: TComboBox;
    WebComboBox3: TComboBox;
    WebComboBox2: TComboBox;
    WebComboBox1: TComboBox;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel6: TLabel;
    Jedzenie: TImageControl;
    WebCheckBox1: TCheckBox;
    WebCheckBox3: TCheckBox;
    WebCheckBox4: TCheckBox;
    WebCheckBox5: TCheckBox;
    WebCheckBox7: TCheckBox;
    WebCheckBox8: TCheckBox;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebEdit14: TEdit;
    WebEdit15: TEdit;
    WebLabel5: TLabel;
    Opis: TImageControl;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    procedure WebComboBox1Click(Sender: TObject);
    procedure WebComboBox2Click(Sender: TObject);
    procedure WebComboBox3Click(Sender: TObject);
    procedure WebComboBox4Click(Sender: TObject);
    procedure WebComboBox5Click(Sender: TObject);
    procedure WebComboBox6Click(Sender: TObject);
  protected procedure LoadDFMValues; override; end;

var
  SubForm2: TSubForm2;

implementation

{$R *.dfm}

uses ufrmMain;

procedure TSubForm2.WebComboBox1Click(Sender: TObject);
var   ILO, ILO_P        : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox1.ItemIndex;
ILO_P:=StrtoFloat(WebEdit6.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
JED:=StrtoFloat(FrmMain.WebEdit1.Text);
PO:=WebComboBox1.ItemIndex;
case PO of
0: ILO:=0.64;
1: ILO:=0.48;
2: ILO:=0.32;
3: ILO:=0.16;
4: ILO:=0.04;
end;
JED:=JED+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox1.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox1.Checked=true then JED:=JED-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit1.Text:=FloattoStr(JED);
WebEdit6.Text:=FloattoStr(ILO);
WebCheckBox1.Checked:=true;
WebComboBox1.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if TAK=6 then  FrmMain.WebEdit7.Text:='1';
end;

procedure TSubForm2.WebComboBox2Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox2.ItemIndex;
ILO_P:=StrtoFloat(WebEdit7.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
JED:=StrtoFloat(FrmMain.WebEdit1.Text);
PO:=WebComboBox2.ItemIndex;
case PO of
0: ILO:=0.81;
1: ILO:=0.6;
2: ILO:=0.4;
3: ILO:=0.24;
4: ILO:=0.1;
5: ILO:=0.03;
6: ILO:=0.02;
end;
JED:=JED+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox3.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox3.Checked=true then JED:=JED-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit1.Text:=FloattoStr(JED);
WebEdit7.Text:=FloattoStr(ILO);
WebCheckBox3.Checked:=true;
WebComboBox2.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if TAK=6 then  FrmMain.WebEdit7.Text:='1';
end;

procedure TSubForm2.WebComboBox3Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox3.ItemIndex;
ILO_P:=StrtoFloat(WebEdit12.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
JED:=StrtoFloat(FrmMain.WebEdit1.Text);
PO:=WebComboBox3.ItemIndex;
case PO of
0: ILO:=0.21;
1: ILO:=0.14;
2: ILO:=0.06;
3: ILO:=0.03;
4: ILO:=0.01;
5: ILO:=0.01;
end;
JED:=JED+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox4.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox4.Checked=true then JED:=JED-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit1.Text:=FloattoStr(JED);
WebEdit12.Text:=FloattoStr(ILO);
WebCheckBox4.Checked:=true;
WebComboBox3.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if TAK=6 then  FrmMain.WebEdit7.Text:='1';
end;

procedure TSubForm2.WebComboBox4Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox4.ItemIndex;
ILO_P:=StrtoFloat(WebEdit13.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
JED:=StrtoFloat(FrmMain.WebEdit1.Text);
PO:=WebComboBox4.ItemIndex;
case PO of
0: ILO:=1.29;
1: ILO:=0.97;
2: ILO:=0.65;
3: ILO:=0.48;
4: ILO:=0.23;
5: ILO:=0.09;
6: ILO:=0.06;
end;
JED:=JED+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox5.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox5.Checked=true then JED:=JED-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit1.Text:=FloattoStr(JED);
WebEdit13.Text:=FloattoStr(ILO);
WebCheckBox5.Checked:=true;
WebComboBox4.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if TAK=6 then  FrmMain.WebEdit7.Text:='1';
end;

procedure TSubForm2.WebComboBox5Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox5.ItemIndex;
ILO_P:=StrtoFloat(WebEdit14.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
JED:=StrtoFloat(FrmMain.WebEdit1.Text);
PO:=WebComboBox5.ItemIndex;
case PO of
0: ILO:=0.02;
1: ILO:=-0.06;
2: ILO:=-0.14;
3: ILO:=-0.22;
4: ILO:=-0.3;
end;
JED:=JED+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox7.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox7.Checked=true then JED:=JED-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit1.Text:=FloattoStr(JED);
WebEdit14.Text:=FloattoStr(ILO);
WebCheckBox7.Checked:=true;
WebComboBox5.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if TAK=6 then  FrmMain.WebEdit7.Text:='1';
end;

procedure TSubForm2.WebComboBox6Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox6.ItemIndex;
ILO_P:=StrtoFloat(WebEdit15.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
JED:=StrtoFloat(FrmMain.WebEdit1.Text);
PO:=WebComboBox6.ItemIndex;
case PO of
0: ILO:=0.55;
1: ILO:=0;
2: ILO:=-0.39;
end;
JED:=JED+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox8.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox8.Checked=true then JED:=JED-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit1.Text:=FloattoStr(JED);
WebEdit15.Text:=FloattoStr(ILO);
WebCheckBox8.Checked:=true;
WebComboBox6.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if TAK=6 then  FrmMain.WebEdit7.Text:='1';
end;
procedure TSubForm2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel26 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  Jedzenie := TImageControl.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  Opis := TImageControl.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebCheckBox8 := TCheckBox.Create(Self);
  WebCheckBox7 := TCheckBox.Create(Self);
  WebCheckBox5 := TCheckBox.Create(Self);
  WebCheckBox4 := TCheckBox.Create(Self);
  WebCheckBox3 := TCheckBox.Create(Self);
  WebCheckBox1 := TCheckBox.Create(Self);
  WebComboBox6 := TComboBox.Create(Self);
  WebComboBox5 := TComboBox.Create(Self);
  WebComboBox4 := TComboBox.Create(Self);
  WebComboBox3 := TComboBox.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit14 := TEdit.Create(Self);
  WebEdit15 := TEdit.Create(Self);

  WebLabel26.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  Jedzenie.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  Opis.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebCheckBox8.BeforeLoadDFMValues;
  WebCheckBox7.BeforeLoadDFMValues;
  WebCheckBox5.BeforeLoadDFMValues;
  WebCheckBox4.BeforeLoadDFMValues;
  WebCheckBox3.BeforeLoadDFMValues;
  WebCheckBox1.BeforeLoadDFMValues;
  WebComboBox6.BeforeLoadDFMValues;
  WebComboBox5.BeforeLoadDFMValues;
  WebComboBox4.BeforeLoadDFMValues;
  WebComboBox3.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit14.BeforeLoadDFMValues;
  WebEdit15.BeforeLoadDFMValues;
  try
    Name := 'SubForm2';
    Width := 708;
    Height := 465;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    WebLabel26.SetParentComponent(Self);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 8;
    WebLabel26.Top := 59;
    WebLabel26.Width := 66;
    WebLabel26.Height := 18;
    WebLabel26.Caption := 'Jedzenie';
    WebLabel26.Font.Charset := DEFAULT_CHARSET;
    WebLabel26.Font.Color := clMenuHighlight;
    WebLabel26.Font.Height := -15;
    WebLabel26.Font.Name := 'Tahoma';
    WebLabel26.Font.Style := [fsBold];
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.ParentFont := False;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 445;
    WebLabel7.Width := 211;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2022';
    WebLabel7.Color := clYellow;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.Transparent := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 9;
    WebLabel13.Top := 84;
    WebLabel13.Width := 224;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Jaki jest udzia'#322' owoc'#243'w i warzyw sezonowych?';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(Self);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 9;
    WebLabel14.Top := 119;
    WebLabel14.Width := 233;
    WebLabel14.Height := 13;
    WebLabel14.Caption := 'Jak cz'#281'sto pijesz mleko i jesz produkty mleczne,?';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(Self);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 9;
    WebLabel16.Top := 154;
    WebLabel16.Width := 252;
    WebLabel16.Height := 13;
    WebLabel16.Caption := 'Jak cz'#281'sto jesz jajka lub produkty zawieraj'#261'ce jajka?';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel21.SetParentComponent(Self);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 9;
    WebLabel21.Top := 193;
    WebLabel21.Width := 255;
    WebLabel21.Height := 13;
    WebLabel21.Caption := 'Jak cz'#281'sto jesz produkty zawieraj'#261'ce mi'#281'so lub ryby?';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebLabel22.SetParentComponent(Self);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 9;
    WebLabel22.Top := 227;
    WebLabel22.Width := 252;
    WebLabel22.Height := 13;
    WebLabel22.Caption := 'Jak'#261' proporcj'#281' maj'#261' produkty EKO/BIO w zakupach?';
    WebLabel22.HeightPercent := 100.000000000000000000;
    WebLabel22.WidthPercent := 100.000000000000000000;
    WebLabel23.SetParentComponent(Self);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 9;
    WebLabel23.Top := 253;
    WebLabel23.Width := 151;
    WebLabel23.Height := 13;
    WebLabel23.Caption := 'Jak cz'#281'sto wyrzucasz jedzenie?';
    WebLabel23.HeightPercent := 100.000000000000000000;
    WebLabel23.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 10;
    WebLabel1.Top := 98;
    WebLabel1.Width := 210;
    WebLabel1.Height := 13;
    WebLabel1.Caption := '(w ca'#322'kowitych zakupach owoc'#243'w i warzyw)';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 133;
    WebLabel2.Width := 200;
    WebLabel2.Height := 13;
    WebLabel2.Caption := '(takie jak jogurt, ser, mas'#322'o lub '#347'mietana)';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 9;
    WebLabel3.Top := 168;
    WebLabel3.Width := 157;
    WebLabel3.Height := 13;
    WebLabel3.Caption := ' (np. nale'#347'niki, desery, majonez)';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 9;
    WebLabel4.Top := 201;
    WebLabel4.Width := 205;
    WebLabel4.Height := 13;
    WebLabel4.Caption := '(np. spaghetti bolognese, bu'#322'ki z '#322'ososiem)';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 10;
    WebLabel6.Top := 266;
    WebLabel6.Width := 208;
    WebLabel6.Height := 13;
    WebLabel6.Caption := '(poniewa'#380' si'#281' zepsu'#322'o lub straci'#322'o wa'#380'no'#347#263')';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    Jedzenie.SetParentComponent(Self);
    Jedzenie.Name := 'Jedzenie';
    Jedzenie.Left := 384;
    Jedzenie.Top := 281;
    Jedzenie.Width := 304;
    Jedzenie.Height := 161;
    Jedzenie.HeightPercent := 100.000000000000000000;
    Jedzenie.WidthPercent := 100.000000000000000000;
    Jedzenie.ChildOrder := 20;
    Jedzenie.Picture.LoadFromFile('uSubForm2.Jedzenie.Picture.jpg');
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 2;
    WebLabel5.Top := 320;
    WebLabel5.Width := 188;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Prosz'#281' odpowiedzie'#263' na ka'#380'de pytanie.';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clBlue;
    WebLabel5.Font.Height := -11;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    Opis.SetParentComponent(Self);
    Opis.Name := 'Opis';
    Opis.Left := 103;
    Opis.Top := 339;
    Opis.Width := 137;
    Opis.Height := 57;
    Opis.HeightPercent := 100.000000000000000000;
    Opis.WidthPercent := 100.000000000000000000;
    Opis.ChildOrder := 3;
    Opis.Picture.LoadFromFile('uSubForm2.Opis.Picture.png');
    WebLabel8.SetParentComponent(Self);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 2;
    WebLabel8.Top := 401;
    WebLabel8.Width := 246;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'Zielone pod'#347'wietlenie oznacza udzielon'#261' odpowied'#378;
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clBlue;
    WebLabel8.Font.Height := -11;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(Self);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 537;
    WebLabel9.Top := 446;
    WebLabel9.Width := 150;
    WebLabel9.Height := 16;
    WebLabel9.Caption := 'Kontakt: biuro@pro-sun.pl';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clBlue;
    WebLabel9.Font.Height := -13;
    WebLabel9.Font.Name := 'Tahoma';
    WebLabel9.Font.Style := [];
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebCheckBox8.SetParentComponent(Self);
    WebCheckBox8.Name := 'WebCheckBox8';
    WebCheckBox8.Left := 300;
    WebCheckBox8.Top := 256;
    WebCheckBox8.Width := 113;
    WebCheckBox8.Height := 22;
    WebCheckBox8.ChildOrder := 21;
    WebCheckBox8.Color := clNone;
    WebCheckBox8.HeightPercent := 100.000000000000000000;
    WebCheckBox8.State := cbUnchecked;
    WebCheckBox8.Visible := False;
    WebCheckBox8.WidthPercent := 100.000000000000000000;
    WebCheckBox7.SetParentComponent(Self);
    WebCheckBox7.Name := 'WebCheckBox7';
    WebCheckBox7.Left := 300;
    WebCheckBox7.Top := 224;
    WebCheckBox7.Width := 113;
    WebCheckBox7.Height := 22;
    WebCheckBox7.ChildOrder := 21;
    WebCheckBox7.Color := clNone;
    WebCheckBox7.HeightPercent := 100.000000000000000000;
    WebCheckBox7.State := cbUnchecked;
    WebCheckBox7.Visible := False;
    WebCheckBox7.WidthPercent := 100.000000000000000000;
    WebCheckBox5.SetParentComponent(Self);
    WebCheckBox5.Name := 'WebCheckBox5';
    WebCheckBox5.Left := 300;
    WebCheckBox5.Top := 191;
    WebCheckBox5.Width := 113;
    WebCheckBox5.Height := 22;
    WebCheckBox5.ChildOrder := 21;
    WebCheckBox5.Color := clNone;
    WebCheckBox5.HeightPercent := 100.000000000000000000;
    WebCheckBox5.State := cbUnchecked;
    WebCheckBox5.Visible := False;
    WebCheckBox5.WidthPercent := 100.000000000000000000;
    WebCheckBox4.SetParentComponent(Self);
    WebCheckBox4.Name := 'WebCheckBox4';
    WebCheckBox4.Left := 300;
    WebCheckBox4.Top := 157;
    WebCheckBox4.Width := 113;
    WebCheckBox4.Height := 22;
    WebCheckBox4.ChildOrder := 21;
    WebCheckBox4.Color := clNone;
    WebCheckBox4.HeightPercent := 100.000000000000000000;
    WebCheckBox4.State := cbUnchecked;
    WebCheckBox4.Visible := False;
    WebCheckBox4.WidthPercent := 100.000000000000000000;
    WebCheckBox3.SetParentComponent(Self);
    WebCheckBox3.Name := 'WebCheckBox3';
    WebCheckBox3.Left := 300;
    WebCheckBox3.Top := 123;
    WebCheckBox3.Width := 113;
    WebCheckBox3.Height := 22;
    WebCheckBox3.ChildOrder := 21;
    WebCheckBox3.Color := clNone;
    WebCheckBox3.HeightPercent := 100.000000000000000000;
    WebCheckBox3.State := cbUnchecked;
    WebCheckBox3.Visible := False;
    WebCheckBox3.WidthPercent := 100.000000000000000000;
    WebCheckBox1.SetParentComponent(Self);
    WebCheckBox1.Name := 'WebCheckBox1';
    WebCheckBox1.Left := 300;
    WebCheckBox1.Top := 89;
    WebCheckBox1.Width := 113;
    WebCheckBox1.Height := 22;
    WebCheckBox1.ChildOrder := 21;
    WebCheckBox1.Color := clNone;
    WebCheckBox1.HeightPercent := 100.000000000000000000;
    WebCheckBox1.State := cbUnchecked;
    WebCheckBox1.Visible := False;
    WebCheckBox1.WidthPercent := 100.000000000000000000;
    WebComboBox6.SetParentComponent(Self);
    WebComboBox6.Name := 'WebComboBox6';
    WebComboBox6.Left := 316;
    WebComboBox6.Top := 256;
    WebComboBox6.Width := 372;
    WebComboBox6.Height := 21;
    WebComboBox6.HeightPercent := 100.000000000000000000;
    WebComboBox6.Text := 'Prawie  nigdy';
    WebComboBox6.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox6, Self, 'OnClick', 'WebComboBox6Click');
    WebComboBox6.ItemIndex := 2;
    WebComboBox6.Items.BeginUpdate;
    try
      WebComboBox6.Items.Clear;
      WebComboBox6.Items.Add('Cz'#281'sto (musz'#281' wyrzuci'#263' cz'#281#347#263' ka'#380'dego zakupu)');
      WebComboBox6.Items.Add('Zdarzy'#322'o mi si'#281' od czasu do czasu');
      WebComboBox6.Items.Add('Prawie  nigdy');
    finally
      WebComboBox6.Items.EndUpdate;
    end;
    WebComboBox5.SetParentComponent(Self);
    WebComboBox5.Name := 'WebComboBox5';
    WebComboBox5.Left := 316;
    WebComboBox5.Top := 224;
    WebComboBox5.Width := 372;
    WebComboBox5.Height := 21;
    WebComboBox5.HeightPercent := 100.000000000000000000;
    WebComboBox5.Text := 'Prawie zero';
    WebComboBox5.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox5, Self, 'OnClick', 'WebComboBox5Click');
    WebComboBox5.ItemIndex := 0;
    WebComboBox5.Items.BeginUpdate;
    try
      WebComboBox5.Items.Clear;
      WebComboBox5.Items.Add('Prawie zero');
      WebComboBox5.Items.Add('Oko'#322'o 1/4');
      WebComboBox5.Items.Add('Oko'#322'o 1/2');
      WebComboBox5.Items.Add('Oko'#322'o 3/4');
      WebComboBox5.Items.Add('Gotuj'#281' prawie wy'#322#261'cznie z produkt'#243'w EKO/BIO');
    finally
      WebComboBox5.Items.EndUpdate;
    end;
    WebComboBox4.SetParentComponent(Self);
    WebComboBox4.Name := 'WebComboBox4';
    WebComboBox4.Left := 316;
    WebComboBox4.Top := 191;
    WebComboBox4.Width := 372;
    WebComboBox4.Height := 21;
    WebComboBox4.HeightPercent := 100.000000000000000000;
    WebComboBox4.Text := 'Wi'#281'cej ni'#380' 3 razy dziennie';
    WebComboBox4.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox4, Self, 'OnClick', 'WebComboBox4Click');
    WebComboBox4.ItemIndex := 0;
    WebComboBox4.Items.BeginUpdate;
    try
      WebComboBox4.Items.Clear;
      WebComboBox4.Items.Add('Wi'#281'cej ni'#380' 3 razy dziennie');
      WebComboBox4.Items.Add('3 razy dziennie');
      WebComboBox4.Items.Add('2 razy dziennie');
      WebComboBox4.Items.Add('1-2 razy dziennie');
      WebComboBox4.Items.Add('4 - 6 razy w tygodniu');
      WebComboBox4.Items.Add('1 - 3 razy w tygodniu');
      WebComboBox4.Items.Add('Rzadziej ni'#380' raz w tygodniu lub nigdy (weganie, alergicy)');
    finally
      WebComboBox4.Items.EndUpdate;
    end;
    WebComboBox3.SetParentComponent(Self);
    WebComboBox3.Name := 'WebComboBox3';
    WebComboBox3.Left := 316;
    WebComboBox3.Top := 157;
    WebComboBox3.Width := 372;
    WebComboBox3.Height := 21;
    WebComboBox3.HeightPercent := 100.000000000000000000;
    WebComboBox3.Text := 'Wi'#281'cej ni'#380' 2 porcje dziennie';
    WebComboBox3.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox3, Self, 'OnClick', 'WebComboBox3Click');
    WebComboBox3.ItemIndex := 0;
    WebComboBox3.Items.BeginUpdate;
    try
      WebComboBox3.Items.Clear;
      WebComboBox3.Items.Add('Wi'#281'cej ni'#380' 2 porcje dziennie');
      WebComboBox3.Items.Add('1 - 2 porcje dziennie');
      WebComboBox3.Items.Add('3 - 6 porcji tygodniowo');
      WebComboBox3.Items.Add('1 - 3 porcje tygodniowo');
      WebComboBox3.Items.Add('Oko'#322'o raz w tygodniu');
      WebComboBox3.Items.Add('Rzadziej ni'#380' raz w tygodniu lub nigdy (weganie, alergicy)');
    finally
      WebComboBox3.Items.EndUpdate;
    end;
    WebComboBox2.SetParentComponent(Self);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 316;
    WebComboBox2.Top := 123;
    WebComboBox2.Width := 372;
    WebComboBox2.Height := 21;
    WebComboBox2.HeightPercent := 100.000000000000000000;
    WebComboBox2.Text := 'Ponad 10 porcji dziennie';
    WebComboBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox2, Self, 'OnClick', 'WebComboBox2Click');
    WebComboBox2.ItemIndex := 0;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('Ponad 10 porcji dziennie');
      WebComboBox2.Items.Add('8-10 porcji dziennie');
      WebComboBox2.Items.Add('5 - 7 porcji dziennie');
      WebComboBox2.Items.Add('3 - 4 porcje dziennie');
      WebComboBox2.Items.Add('1 - 2 porcje dziennie');
      WebComboBox2.Items.Add('1 - 6 porcji tygodniowo');
      WebComboBox2.Items.Add('Rzadziej ni'#380' raz w tygodniu lub nigdy (weganie, alergicy)');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebComboBox1.SetParentComponent(Self);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 316;
    WebComboBox1.Top := 88;
    WebComboBox1.Width := 372;
    WebComboBox1.Height := 21;
    WebComboBox1.HeightPercent := 100.000000000000000000;
    WebComboBox1.Text := 'Ma'#322'o';
    WebComboBox1.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox1, Self, 'OnClick', 'WebComboBox1Click');
    WebComboBox1.ItemIndex := 0;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('Ma'#322'o');
      WebComboBox1.Items.Add('Oko'#322'o 1/4');
      WebComboBox1.Items.Add('Oko'#322'o 1/2');
      WebComboBox1.Items.Add('Oko'#322'o 3/4');
      WebComboBox1.Items.Add('Prawie wszystkie kupowane owoce i warzywa pochodz'#261' z lokalnych '#378);
      WebComboBox1.Items.Add('r'#243'de'#322' i s'#261' sezonowe');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebEdit6.SetParentComponent(Self);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 256;
    WebEdit6.Top := 88;
    WebEdit6.Width := 38;
    WebEdit6.Height := 22;
    WebEdit6.ChildOrder := 30;
    WebEdit6.HeightPercent := 100.000000000000000000;
    WebEdit6.Text := '0';
    WebEdit6.Visible := False;
    WebEdit6.WidthPercent := 100.000000000000000000;
    WebEdit7.SetParentComponent(Self);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 256;
    WebEdit7.Top := 123;
    WebEdit7.Width := 38;
    WebEdit7.Height := 22;
    WebEdit7.ChildOrder := 30;
    WebEdit7.HeightPercent := 100.000000000000000000;
    WebEdit7.Text := '0';
    WebEdit7.Visible := False;
    WebEdit7.WidthPercent := 100.000000000000000000;
    WebEdit12.SetParentComponent(Self);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 257;
    WebEdit12.Top := 157;
    WebEdit12.Width := 38;
    WebEdit12.Height := 22;
    WebEdit12.ChildOrder := 30;
    WebEdit12.HeightPercent := 100.000000000000000000;
    WebEdit12.Text := '0';
    WebEdit12.Visible := False;
    WebEdit12.WidthPercent := 100.000000000000000000;
    WebEdit13.SetParentComponent(Self);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 256;
    WebEdit13.Top := 191;
    WebEdit13.Width := 38;
    WebEdit13.Height := 22;
    WebEdit13.ChildOrder := 30;
    WebEdit13.HeightPercent := 100.000000000000000000;
    WebEdit13.Text := '0';
    WebEdit13.Visible := False;
    WebEdit13.WidthPercent := 100.000000000000000000;
    WebEdit14.SetParentComponent(Self);
    WebEdit14.Name := 'WebEdit14';
    WebEdit14.Left := 257;
    WebEdit14.Top := 224;
    WebEdit14.Width := 38;
    WebEdit14.Height := 22;
    WebEdit14.ChildOrder := 30;
    WebEdit14.HeightPercent := 100.000000000000000000;
    WebEdit14.Text := '0';
    WebEdit14.Visible := False;
    WebEdit14.WidthPercent := 100.000000000000000000;
    WebEdit15.SetParentComponent(Self);
    WebEdit15.Name := 'WebEdit15';
    WebEdit15.Left := 257;
    WebEdit15.Top := 256;
    WebEdit15.Width := 38;
    WebEdit15.Height := 22;
    WebEdit15.ChildOrder := 30;
    WebEdit15.HeightPercent := 100.000000000000000000;
    WebEdit15.Text := '0';
    WebEdit15.Visible := False;
    WebEdit15.WidthPercent := 100.000000000000000000;
  finally
    WebLabel26.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    Jedzenie.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    Opis.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebCheckBox8.AfterLoadDFMValues;
    WebCheckBox7.AfterLoadDFMValues;
    WebCheckBox5.AfterLoadDFMValues;
    WebCheckBox4.AfterLoadDFMValues;
    WebCheckBox3.AfterLoadDFMValues;
    WebCheckBox1.AfterLoadDFMValues;
    WebComboBox6.AfterLoadDFMValues;
    WebComboBox5.AfterLoadDFMValues;
    WebComboBox4.AfterLoadDFMValues;
    WebComboBox3.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit14.AfterLoadDFMValues;
    WebEdit15.AfterLoadDFMValues;
  end;
end;

end.
